<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="container">
      <app-spinner *ngIf="!blogContent"></app-spinner>
      <div class="row" *ngIf="blogContent">
        <div class="col">

          <div class="blog-post">
            <h1 class="blog-post-title">{{blogContent.title}}</h1>
            <p class="blog-post-meta">{{blogContent.createdAt | date}} by Orcun</p>
            <img src="resources/{{blogContent.image}}" class="img-blog"  alt="{{blogContent.title}}"/>
             <div [innerHtml]="blogContent.content"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
